import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService, InitDataService, Logger } from '../../system-services';

@Injectable({
    providedIn: 'root'
})
export class PardotService {
    pardotExternalActivitiesURL =
        'https://p2x262gjjj.execute-api.us-east-1.amazonaws.com/prod/softwarepardotnotifications';
    pardotPricingPackagingURL =
        'https://go1.predictiveindex.com/l/492541/2022-11-15/d4byls';

    constructor(
        private api: ApiService,
        private initData: InitDataService,
        private logger: Logger
    ) {}

    get currentLoggedInUserEmail(): string {
        return this.initData.user.email;
    }

    async pushPardotExternalActivity(
        eventName: string,
        category = 'Product_Activity'
    ) {
        await this.apiToPardot(eventName, category);
    }

    public async sendPricingPackagingPartnerRequest(
        originalLeadSource: string
    ) {
        const contentBody = `email=${this.currentLoggedInUserEmail}&original_source=${originalLeadSource}`;

        let headers = new HttpHeaders();

        headers = headers.set(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
        );

        try {
            await this.api.http
                .post(this.pardotPricingPackagingURL, contentBody, {
                    headers: headers
                })
                .toPromise()
                .then((response) => response);

            this.logPardotRequest(originalLeadSource, 'Pardot Form Handler');
        } catch (error) {
            this.logger.logError(
                'Pardot Pricing & Packaging API call failed to POST',
                {
                    error: error,
                    email: this.currentLoggedInUserEmail
                }
            );
        }
    }

    private logPardotRequest(eventName: string, category: string) {
        this.logger.logInfo(
            'Pardot External Activity Sent: Event Name: ' +
                eventName +
                ' Category: ' +
                category,
            {
                userId: this.initData.user.userId,
                email: this.initData.user.email,
                companyId: this.initData.user.companyId
            }
        );
    }

    private async apiToPardot(eventName: string, category: string) {
        const contentBody = `email=${this.currentLoggedInUserEmail}&name=${eventName}&category=${category}`;

        let headers = new HttpHeaders();

        headers = headers.set(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
        );

        try {
            await this.api.http
                .post(this.pardotExternalActivitiesURL, contentBody, {
                    headers: headers
                })
                .toPromise()
                .then((response) => response);

            this.logPardotRequest(eventName, category);
        } catch (error) {
            this.logger.logError('Pardot API call failed to POST', {
                error: error,
                email: this.currentLoggedInUserEmail
            });
        }
    }
}
